import { motion } from "framer-motion";
import { MANIFESTO } from "@/constants/testIds";

const CHAPTERS = [
  {
    n: "01",
    title: "Two decades. One obsession.",
    body:
      "Since 2005, Dove Infotech has quietly built software for teams who care about how things feel — not just how they work. Twenty years is a long time to keep sharpening the same craft. We wouldn't have it any other way.",
  },
  {
    n: "02",
    title: "Design and engineering, in the same room.",
    body:
      "We refuse the hand-off. Designers ship. Engineers sketch. Editors debate typography. When you work with us, you get one small, senior team from first pixel to production — not a relay race.",
  },
  {
    n: "03",
    title: "Products that outlast the trend cycle.",
    body:
      "Fashions come and go. Fundamentals don't. We build for clarity, speed, and longevity — codebases that stay readable at year five, interfaces that still feel considered at year ten.",
  },
];

export const Manifesto = () => {
  return (
    <section
      id="about"
      data-testid={MANIFESTO.section}
      className="relative py-32 md:py-44"
    >
      <div className="mx-auto max-w-[1400px] px-6 md:px-10">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.8 }}
          className="max-w-2xl mb-20 md:mb-28"
        >
          <div className="flex items-center gap-3 text-[11px] uppercase tracking-[0.28em] text-emerald-300/80 mb-6">
            <span className="inline-block w-1.5 h-1.5 rounded-full bg-emerald-400" />
            Manifesto
          </div>
          <h2 className="font-display font-bold text-white text-4xl md:text-5xl lg:text-6xl tracking-tight leading-[0.98]">
            A quiet studio, <br />
            <span className="italic font-normal text-emerald-300">obsessively opinionated.</span>
          </h2>
        </motion.div>

        <div className="space-y-16 md:space-y-24">
          {CHAPTERS.map((c, i) => (
            <motion.div
              key={c.n}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.9, delay: i * 0.08, ease: [0.22, 0.61, 0.36, 1] }}
              className="grid grid-cols-12 gap-6 md:gap-10 items-start"
            >
              <div className="col-span-12 md:col-span-4">
                <span className="font-display font-black text-emerald-400/90 text-[22vw] md:text-[10vw] lg:text-[9vw] leading-none block">
                  {c.n}
                </span>
              </div>
              <div className="col-span-12 md:col-span-7 md:col-start-6 pt-2 md:pt-6">
                <h3 className="font-display font-bold text-white text-2xl md:text-3xl lg:text-4xl tracking-tight leading-tight mb-5">
                  {c.title}
                </h3>
                <p className="text-white/65 text-base md:text-lg leading-relaxed max-w-[52ch]">
                  {c.body}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
